


















































import { Component, Vue, Ref } from 'vue-property-decorator';
import { Comune } from '@/data/models/comune.model';
import { Provincia } from '@/data/models/provincia.model';
import { Search } from '@/data/models/search.model';
import { ClassType } from 'class-transformer/ClassTransformer';

@Component
export default class HeadquarterFilter extends Vue {
	@Ref('autocompleteprovincia') autocompleteprovincia: any;
	@Ref('autocompletecomune') autocompletecomune: any;

	advancedSearch: Search;

	searchParam: any = new class {
		name?: string;
		province?: string;
		city?: string;
	};

	provinciaClass: ClassType<Provincia> = Provincia;
	comuneClass: ClassType<Comune> = Comune;

	constructor() {
		super();
		this.advancedSearch = new Search('headquarter');
	}

	search() {
		this.advancedSearch.reset();
		this.advancedSearch.addSimpleFilter('active', 1);

		if (this.searchParam.name) this.advancedSearch.addLikeFilter('name', this.searchParam.name);
		if (this.searchParam.province && this.searchParam.province.id) this.advancedSearch.addSimpleFilter('province', this.searchParam.province.descrizione);
		if (this.searchParam.city && this.searchParam.city.id) this.advancedSearch.addLikeFilter('city', this.searchParam.city.descrizione);

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.name = undefined;
		this.searchParam.province = {};
		this.searchParam.city = {};
		this.search();
	}

}
